import { useTranslation, Trans } from "react-i18next";
import { ITermsData } from "./interfaces";
import pageData from "@/i18n/json/terms/en.json";
import { paramCase } from "change-case";

// Styles
import { heading, content, link } from "./styles/terms-data";
import ContentHeading from "../content-heading";
import { wrapper } from "@/components/terms/styles/terms-hero";

const TermsData: React.FC<ITermsData> = () => {
  const { t } = useTranslation();

  return (
    <section className={wrapper}>
      <div>
        <ContentHeading
          h="p"
          className="justify-center"
          backdropPosition="mobile:left-4 tablet:left-8"
          fontSize="mobile:text-3xl tablet:text-5xl"
          background="bg-primary bg-opacity-60"
        >
          Terms &amp; Conditions
        </ContentHeading>
      </div>
      <br />
      <br />
      {/* heading */}
      {pageData["terms"].map((item: ITermsData, index: number) => {
        return (
          <div key={index}>
            <p id={paramCase(item.heading)} className={heading}>
              <Trans>
                <strong>{item.heading}</strong>
              </Trans>
            </p>
            <p className={content}>
              <Trans
                components={{
                  q: <q />,
                  a: <a className={link} />,
                  ul: <ul />,
                  li: <li />,
                }}
              >
                {item.content}
              </Trans>
            </p>
          </div>
        );
      })}
    </section>
  );
};

export default TermsData;

{
}
